import logoPic from '@root/public/images/logo.svg';
import Image from 'next/image';

import s from './Logo.module.css';

const Logo = () => {
  return <Image data-testid="logo" src={logoPic} alt="Logo" className={s.logo} priority />;
};

export default Logo;
